<template>
  <div id="operate-btns">
    <div v-if="traceStatus !== '13'">
      <ux-button v-if="state === '1'" class="custom mr-10" value="large" :disabled="timeOver" @click="cancelSign">
        取消报名
      </ux-button>
      <ux-button v-if="state === '2'" class="mr-10" value="large" :disabled="true">
        已取消
      </ux-button>
      <ux-button v-if="state === '1' && traceStatus === '11'" class="mr-10" :disabled="true" value="large">
        商户筛选中
      </ux-button>
      <ux-button v-if="state === '4'" class="custom mr-10" value="large" @click="gotoFwsPage">
        恭喜，您的方案已被选中，点击查看
      </ux-button>
      <ux-button v-if="state === '3'" class="mr-10" value="large" :disabled="true">
        抱歉，您的方案未被选中
      </ux-button>
      <a v-if="state === '3'" class="ml-20" @click="gotoSquare">查看其它需求>>></a>
      </div>
  </div>
</template>>
<script>
import { gotoFwsCustomzied } from '@/common/utils/utils.js';
export default {
  props: {
    state: {
      type: String,
      default: ''
    },
    traceStatus: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      timeOver: true
    }
  },
  watch: {
    endTime(value) {
      if(value !== '') {
        const endTime = `${value} 23:59:59`
        const now = new Date().getTime();
        const end = new Date(endTime).getTime();
        console.log(end - now < 0, '111')
        this.timeOver = end - now < 0;
      }
    },
    
  },
  // computed: {
  //   timeOver() {
  //     const endTime = `${this.endTime} 23:59:59`
  //     const now = new Date().getTime();
  //     const end = new Date(endTime).getTime();
  //     console.log(end - now < 0, '111')
  //     return end - now < 0
  //   },
  // },
  methods: {
    cancelSign() {
      this.$emit('cancelSign')
    },
    gotoSquare() {
      this.$router.push({name: 'square'})
    },
    gotoFwsPage() {
      gotoFwsCustomzied();
    }
  }
}
</script>
<style scoped>
.custom {
  background: red;
  color: #ffffff;
}
.custom[disabled] {
  color: #aaa;
  background-color: #f5f5f5;
  border-color: #d9d9d9;
}
</style>